import React from 'react';
import compose from 'lodash/fp/compose';
import { withPageType } from '@catalogo/core-connect/page-type';
import { withCookies } from '@catalogo/core-connect/cookies';
import { getLoggedCustomer } from '@catalogo/service-americanas-common/src/helpers/customer';

export const withLogin = WrappedComponent => {
  const EnhancedLogin = ({ cookies, pageType, publication }) => {
    const { customerToken: token, customerNickname: nickname } = getLoggedCustomer(cookies);
    const name = decodeURI(nickname);
    const recommendedList = publication?.recommendedList?.filter(rec => rec?.products?.length > 0);

    if (!recommendedList?.length > 0) {
      return <></>;
    }

    return <WrappedComponent token={token} name={name} recommendedList={recommendedList} pageType={pageType} />;
  };

  return compose(withPageType, withCookies)(EnhancedLogin);
};
